module.exports = "/_next/static/images/ourPartnersFatbeamLogo-bcc9145d0c435571695e311de654fd19.webp";